export class ChangePasswordModel {
            /// <summary>
        /// The existing user password
        /// </summary>
        public ExistingPassword:string;

        /// <summary>
        /// New password
        /// </summary>
        public NewPassword:string;

        /// <summary>
        /// Confirm the new passsword
        /// </summary>
        public ConfirmNewPassword:string;
        
        /// <summary>
        /// The user id
        /// </summary>
        public PatientId:Number;

}



// WEBPACK FOOTER //
// ./src/app/models/change-password-model.ts